import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import oddsServices from '../services/OddsServices';
import SelectLeagueAction from '../actions/SelectLeagueAction';
import { Mode, E_SPORT_ID, Market } from '../common/Foundation';

const defaultState = {
  loading: false,
  hasErrors: false,
  leagues: [],
  selectedLeagues: [],
  allLeagueIds: [],
  isApplyFilterAllLeagues: false,
  isSelectedAllLeagues: false
}

export const SelectLeaguesSlice = createSlice({
    name: 'SelectLeaguesSlice',
    initialState: { ...defaultState, filterLeagues: [], historySportLeagues: [], historyEsportLeagues: []},
    reducers: {
      getLeaguesStart: state => {
        state.loading = true;
      },
      getLeaguesSuccess: (state, { payload = [] }) => {
        state.loading = false;
        state.hasError = false;
        const data = payload[0] || [];
        const leagues = SelectLeagueAction.convertToSelectLeagues(data[2], Mode.NORMAL);
        state.leagues = leagues;
        state.allLeagueIds = _.map(leagues, league => league.leagueId);
        const isSelectedAllLeagues = SelectLeagueAction.checkSelectedAllLeagues(state.allLeagueIds, state.selectedLeagues, state.isSelectedAllLeagues);
        if (isSelectedAllLeagues !== state.isSelectedAllLeagues) {
          state.isSelectedAllLeagues = isSelectedAllLeagues;
        }
      },
      getTeaserLeaguesSuccess: (state) => {
        state.loading = false;
        state.hasError = false;
      },
      getESportLeaguesSuccess: (state, { payload = [] }) => {
        state.loading = false;
        state.hasError = false;
        const leagues = SelectLeagueAction.convertToESportSelectLeagues(payload);
        state.leagues = leagues;
        state.allLeagueIds = _.map(leagues, league => league.leagueId);

        const isSelectedAllLeagues = SelectLeagueAction.checkSelectedAllLeagues(state.allLeagueIds, state.selectedLeagues, state.isSelectedAllLeagues);
        if (isSelectedAllLeagues !== state.isSelectedAllLeagues) {
          state.isSelectedAllLeagues = isSelectedAllLeagues;
        }
      },
      getOutrightLeaguesSuccess: (state, { payload = [] }) => {
        state.loading = false;
        state.hasError = false;
        const leagues = SelectLeagueAction.convertToSelectLeagues(payload, Mode.OUTRIGHT);
        state.leagues = leagues;
        state.allLeagueIds = _.map(leagues, league => league.leagueId);
        
        const isSelectedAllLeagues = SelectLeagueAction.checkSelectedAllLeagues(state.allLeagueIds, state.selectedLeagues, state.isSelectedAllLeagues);
        if (isSelectedAllLeagues !== state.isSelectedAllLeagues) {
          state.isSelectedAllLeagues = isSelectedAllLeagues;
        }
      },
      getLeaguesFailure: state => {
        state.loading = false;
        state.hasErrors = true;
      },
      updateTeaserLeagues: (state, { payload = [] }) => {
        const leagues = SelectLeagueAction.convertToSelectLeagues(payload, Mode.TEASER);
        state.leagues = leagues;
        state.allLeagueIds = _.map(leagues, league => league.leagueId)
      },
      updateAllSelectedLeagues: (state, { payload = false }) => {
        state.isSelectedAllLeagues = payload;
        if (payload) {
          state.selectedLeagues = [];
        }
      },
      updateSelectedLeagues: (state, { payload = [] }) => {
        state.selectedLeagues = payload;
        state.filterLeagues = payload;
      },
      onSelectLeague: (state, { payload = {leagueId: 0, checked: false} }) => {
        const { leagueId, checked } = payload;
        let isSelectedAllLeagues = false;
        let selectedLeagues = state.selectedLeagues;

        if (state.isSelectedAllLeagues) {
          isSelectedAllLeagues = false;
          selectedLeagues = _.filter(state.allLeagueIds, id => {
            return id !== leagueId;
          });
        } else {
          if (checked) {
            selectedLeagues.push(leagueId);
          } else {
            selectedLeagues = _.filter(selectedLeagues, id => id !== leagueId);
          }
          isSelectedAllLeagues = SelectLeagueAction.checkSelectedAllLeagues(state.allLeagueIds, selectedLeagues);
        }

        state.isSelectedAllLeagues = isSelectedAllLeagues;
        state.selectedLeagues = isSelectedAllLeagues ? [] : selectedLeagues;
      },
      onCancelSelectLeague: (state) => {
        const { filterLeagues } = state;
        state.selectedLeagues = filterLeagues;
          state.isSelectedAllLeagues = state.isApplyFilterAllLeagues
      },
      onApplySelectLeague: (state, {payload}) => {
        return {...state, ...payload};
      },
      cleanupSelectLeagues: (state, {payload = {sportId: 0, selectedMarketTab: '', selectedMarketId: '', selectedEsportGame: ''}}) => {
        const historySportLeagues = state.historySportLeagues;
        const historyEsportLeagues = state.historyEsportLeagues;
        Object.assign(state, defaultState);
        let leaguesHistory = {};
        if(payload.sportId === E_SPORT_ID) {
          leaguesHistory = historyEsportLeagues.find(league => league.selectedEsportGame === payload.selectedEsportGame);
        } else {
          leaguesHistory = historySportLeagues.find(league => league.sportId === payload.sportId);
        }
        let selectedLeaguesHistory = [];
        if (leaguesHistory && leaguesHistory.selectedLeagues.length > 0) {
          const findLeague = leaguesHistory.selectedLeagues.find(league => league.selectedMarketTab === payload.selectedMarketTab && league.selectedMarketId === payload.selectedMarketId);
          if (findLeague) {
            selectedLeaguesHistory = findLeague.leaguesHistory
            state.isSelectedAllLeagues = findLeague.isSelectedAllLeagues;
            state.isApplyFilterAllLeagues = findLeague.isSelectedAllLeagues;
          }
        }
        state.selectedLeagues = selectedLeaguesHistory;
        state.filterLeagues = selectedLeaguesHistory
      }
    },
  }
);
  
export const {
  getLeaguesStart,
  getLeaguesSuccess,
  getESportLeaguesSuccess,
  getOutrightLeaguesSuccess,
  getLeaguesFailure,
  onApplySelectLeague,
  updateSelectedLeagues,
  updateAllSelectedLeagues
} = SelectLeaguesSlice.actions;

export const selectLeaguesSelector = state => state.SelectLeaguesSlice;
export default SelectLeaguesSlice.reducer;

export const fetchLeagues = (parameters) => {
  return async (dispatch) => {
    try {
      const response =  await oddsServices.getLeagues(parameters).then(res => {
        return res.data;
      }).catch(e => {
        dispatch(getLeaguesFailure());
      });
    
      dispatch(getLeaguesSuccess(response))
    } catch (error) {
      dispatch(getLeaguesFailure())
    }
  }
}

export const fetchOutrightLeagues = (parameters) => {
  return async (dispatch) => {
    try {
      const response =  await oddsServices.getOutrightLeagues(parameters).then(res => {
        return res.data;
      }).catch(e => {
        dispatch(getLeaguesFailure());
      });
    
      dispatch(getOutrightLeaguesSuccess(response))
    } catch (error) {
      dispatch(getLeaguesFailure())
    }
  }
}

export const fetchEsportLeagues = (parameters) => {
  return async (dispatch) => {
    try {
      const response =  await oddsServices.getEsportLeagues(parameters).then(res => {
        return res.data;
      }).catch(e => {
        dispatch(getLeaguesFailure());
      });
      dispatch(getESportLeaguesSuccess(response))
    } catch (error) {
      dispatch(getLeaguesFailure())
    }
  }
}

export const applySelectedLeagues = (options, selectedEsportGame) => {
  return async (dispatch, getSlice) => {
    const {allLeagueIds, selectedLeagues, historyEsportLeagues, historySportLeagues, isSelectedAllLeagues} = getSlice().SelectLeaguesSlice;
    const isValidSelectedAllLeagues = SelectLeagueAction.checkSelectedAllLeagues(allLeagueIds, selectedLeagues, isSelectedAllLeagues);
    const leaguesHistory = options.sportId === E_SPORT_ID ? historyEsportLeagues : historySportLeagues
    const selectedMarketTab = (_.invert(Market)[options.market] || "").toUpperCase();
    const selectedMarketId = [options.betTypeGroup, options.period].join('|');
    const selectionLeagues = SelectLeagueAction.updateLeaguesHistory(leaguesHistory, options.sportId, isValidSelectedAllLeagues, selectedLeagues, selectedMarketTab, selectedMarketId, selectedEsportGame);
    const selectedLeague =  options.sportId === E_SPORT_ID ? {historyEsportLeagues: selectionLeagues} : {historySportLeagues: selectionLeagues};
    dispatch(onApplySelectLeague({ 
      ...selectedLeague,
      filterLeagues: isValidSelectedAllLeagues ? [] : selectedLeagues,
      isApplyFilterAllLeagues: isValidSelectedAllLeagues
    }));
    return getSlice().SelectLeaguesSlice.filterLeagues;
  }
}


// WEBPACK FOOTER //
// ./src/app/slices/SelectLeaguesSlice.js